import { ClockTimestamp } from '@sqior/js/data';
import { Entity, EntityHeader } from '@sqior/js/entity';
import { OperationSpec, OperationType } from '@sqior/js/operation';

/* Entity representing the input parameter options of a transport */

export const TransportOrderInputType = 'TransportOrderInput';
export type TransportOrderLocationInput = { label: string; select: Entity };
export type TransportOrderInput = EntityHeader & {
  from: TransportOrderLocationInput[];
  to: TransportOrderLocationInput[];
  options: boolean;
  related?: Entity;
};

/* Entity representing the selected input parameters of a transport order */

export const TransportOrderParametersType = 'TransportOrderParameters';
export type TransportOrderParameters = EntityHeader & {
  from: Entity;
  to: Entity;
  priority: number;
  infectious: boolean;
  comment?: string;
  pickUpTimestamp?: ClockTimestamp;
  related?: Entity;
};
export function makeTransportOrderParameters(
  from: Entity,
  to: Entity,
  priority: number,
  infectious: boolean,
  comment?: string,
  pickUpTimestamp?: ClockTimestamp,
  related?: Entity
): TransportOrderParameters {
  const res: TransportOrderParameters = {
    entityType: TransportOrderParametersType,
    from,
    to,
    priority,
    infectious,
  };
  if (comment) res.comment = comment;
  if (pickUpTimestamp) res.pickUpTimestamp = pickUpTimestamp;
  if (related) res.related = related;
  return res;
}

/** Entity representing the parameter options for selecting a transport location */

export const TransportLocationSelectionType = 'TransportLocationSelection';
export type TransportLocationSelection = EntityHeader & {
  title: string;
};

/** Stream operation for searching locations  */

export const TransportLocationSearchPath = 'search-transport-location';
export type TransportLocationSearchResult = TransportOrderLocationInput & { id: string };
export const TransportLocationSearch: OperationSpec<string> = {
  type: OperationType.Stream,
  path: TransportLocationSearchPath,
  data: '',
};
